<template>
  <div>
    <v-form
      ref="formAef"
      v-model="isFormAefValid"
      lazy-validation>
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs12>
            <v-img
              :src="aefImage"
              data-testId="img"
              style="background-position: left center !important;"
              contain
              max-height="168"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          v-if="isAefDensityType"
          wrap>
          <v-flex
            xs12
            md12
            lg12>
            <span
              data-testId="span-AEF-thresholds"
              class="caption grey--text font-weight-light">
              {{ $t('AEF thresholds') + ' (API - ' + $t('kg/m3') + ')' }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="tank.densityCompManual"
              :label="`${ 'T2 - ' + $t('product density') }`"
              data-testId="text-field-T2-product-density"
              disabled="true"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="tank.aefSeparationThreshold"
              :disabled="features.weightsMeasuresLock"
              :rules="rules.required.concat(rules.density_APIkG)"
              :label="`${ 't2 - ' + $t('ETHANOL') + ' - ' + $t('alarm threshold') }`"
              data-testId="text-field-t2-ETHANOL-alarm-threshold"
              class="dover-input"
              @change="checkValues()"/>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="tank.aefWaterThreshold"
              :disabled="features.weightsMeasuresLock"
              :rules="rules.required.concat(rules.density_APIkG)"
              :label="`${ 't1 - ' + $t('WATER') + ' - ' + $t('alarm threshold') }`"
              data-testId="text-field-t1-WATER-alarm-threshold"
              class="dover-input"
              @change="checkValues()"/>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="densityWater"
              :label="`${ 'T1 - ' + $t('water density') }`"
              data-testId="text-field-T1-water-density"
              disabled="true"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="measurement.aefDensComp"
              :label="`${ $t('Current AEF reading / TC density') }`"
              data-testId="text-field-Current-AEF-reading-TC-density"
              disabled="true"
              class="dover-input"/>
          </v-flex>
          <v-expansion-panel
            v-model="coefficientExpanded">
            <v-expansion-panel-content >
              <template v-slot:header>
                <div>{{ $t('Coefficient settings') }}</div>
              </template>
              <v-card data-testId="card">
                <v-card-text data-testId="card-text">
                  <v-container
                    fill-height
                    fluid
                    grid-list-xl>
                    <v-layout
                      wrap>
                      <v-flex
                        xs6
                        md3>
                        <v-text-field
                          v-model.number="tank.probeAefDensmeterCoeffA"
                          :disabled="features.weightsMeasuresLock"
                          :rules="rules.required.concat(rules.negative)"
                          :label="`${ $t('Coefficient {0}', ['A']) }`"
                          data-testId="text-field-Coefficient-A"
                          class="dover-input"
                          @change="onCoefficientChange()" />
                      </v-flex>
                      <v-flex
                        xs6
                        md3>
                        <v-text-field
                          v-model.number="tank.probeAefDensmeterCoeffB"
                          :disabled="features.weightsMeasuresLock"
                          :rules="rules.required.concat(rules.positive)"
                          :label="`${ $t('Coefficient {0}', ['B']) }`"
                          data-testId="text-field-Coefficient-B"
                          class="dover-input"
                          @change="onCoefficientChange()" />
                      </v-flex>
                      <v-flex
                        xs12
                        md6/>
                      <v-flex
                        xs6
                        md3>
                        <v-text-field
                          v-model.number="coefficientDensity"
                          :disabled="features.weightsMeasuresLock"
                          :rules="rules.required.concat(rules.density_APIkG_0)"
                          :label="`${ $t('Density') + ' (' + $t('hydrometer') + ')' }`"
                          data-testId="text-field-Density-hydrometer"
                          class="dover-input"
                          @change="onCoeffDensityChange()" />
                      </v-flex>
                      <v-flex
                        xs6
                        md3>
                        <v-text-field
                          v-model.number="coefficientDensityComp"
                          :disabled="features.weightsMeasuresLock"
                          :rules="rules.required.concat(rules.density_APIkG_0)"
                          :label="`${ $t('TC Density') + ' (' + $t('hydrometer') + ')' }`"
                          data-testId="text-field-TC-Density-hydrometer"
                          class="dover-input"
                          @change="onCoeffDensityCompChange()" />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-container>
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          v-if="!isAefDensityType"
          wrap>
          <v-flex
            xs12
            md12
            lg12>
            <span
              data-testId="span-AEF-thresholds"
              class="caption grey--text font-weight-light">
              {{ $t('AEF thresholds') + ' (' + [ options.levelUnits[systemSettings.levelUnit || 0].desc ] + ')' }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="tank.aefT2outerLevel"
              :rules="rules.required.concat(rules.level)"
              :label="`${ 'T2 - ' + $t('Product reading') }`"
              data-testId="text-field-T2-Product-reading"
              class="dover-input"
              @change="checkValues()"/>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="tank.aefT2innerLevel"
              :disabled="features.weightsMeasuresLock"
              :rules="rules.required.concat(rules.level)"
              :label="`${ 't2 - ' + $t('ETHANOL') + ' - ' + $t('alarm threshold') }`"
              data-testId="text-field-t2-ETHANOL-alarm-threshold-2"
              class="dover-input"
              @change="checkValues()"/>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="tank.aefT1innerLevel"
              :disabled="features.weightsMeasuresLock"
              :rules="rules.required.concat(rules.level)"
              :label="`${ 't1 - ' + $t('WATER') + ' - ' + $t('alarm threshold') }`"
              data-testId="text-field-t1-WATER-alarm-threshold-2"
              class="dover-input"
              @change="checkValues()"/>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="tank.aefT1outerLevel"
              :rules="rules.required.concat(rules.level)"
              :label="`${ 'T1 - ' + $t('Water reading') }`"
              data-testId="text-field-T1-Water-reading"
              class="dover-input"
              @change="checkValues()"/>
          </v-flex>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.number="measurement.finePgAefLevel"
              :label="`${ $t('Current AEF reading') }`"
              data-testId="text-field-Current-AEF-reading"
              disabled="true"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs6
            md4
            text-xs-left>
            <v-btn
              :disabled="features.weightsMeasuresLock || !Maglink.IsAdminUser()"
              data-testId="btn-Apply-dry-reading-T0"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="applyT0()">
              {{ $t('Apply dry reading (T0)') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs12
            md12
            text-xs-right>
            <v-btn
              :disabled="features.weightsMeasuresLock || !isFormAefValid || !Maglink.IsAdminUser()"
              data-testId="btn-Save"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="saveTank()">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    tank: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    features: {
      type: Object,
      required: true,
      default: () => {}
    },
    measurement: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isFormAefValid: true,
    isTankApiDegree: false,
    aefImage: '',
    coefficientExpanded: 0,
    coefficientDensity: 0.0,
    coefficientDensityComp: 0.0,
    coefficientHeight: 0.0,
    coefficientBeta: 1.0,
    densityWater: 1000.0,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      level: [ v => Vue.prototype.Maglink.RulesRange(v, 0.0, 1000) ],
      positive: [ v => Vue.prototype.Maglink.RulesRange(v, 0.0, 10000) ],
      negative: [ v => Vue.prototype.Maglink.RulesRange(v, -1000.0, 0.0) ],
      density_APIkG: [ v => Vue.prototype.Maglink.RulesRange(v, 1.5, 1075) ],
      density_APIkG_0: [ v => Vue.prototype.Maglink.RulesRange(v, 0, 1075) ]
    }
  }),
  computed: {
    isAefDensityType () {
      return (this.tank.probeType === 12 || this.tank.probeType === 18) // only OPW 924
    }
  },
  mounted () {
    this.isTankApiDegree = this.Maglink.isApiDegree(this.tank.densityCompManual)
    if (this.isAefDensityType) {
      this.aefImage = './img/alarm/aef_thresholds_opw.png'
    } else {
      this.aefImage = './img/alarm/aef_thresholds_pg.png'
    }
    if (this.isTankApiDegree) {
      this.densityWater = 10
    } else {
      if (this.systemSettings.referenceTemperature < 15.1) {
        this.densityWater = 999.06
      } else {
        this.densityWater = 998.19
      }
    }

    this.initCoefficients()
  },
  methods: {
    initCoefficients () {
      if (this.isAefDensityType) {
        this.coefficientDensity = this.Maglink.RoundFormat(this.densityToDisplay(this.tank.lastMeasurement.aefDens), 2)
        this.coefficientDensityComp = this.Maglink.RoundFormat(this.densityToDisplay(this.tank.lastMeasurement.aefDensComp), 2)
        this.calculateCoefficientHeight()
        if (this.coefficientDensity > 0.1 && this.coefficientDensityComp > 0.1) {
          this.coefficientBeta = this.Maglink.fromApiDegree(this.tank.lastMeasurement.aefDensComp) / this.Maglink.fromApiDegree(this.tank.lastMeasurement.aefDens)
        }
      }
    },
    calculateCoefficientHeight () {
      if (this.tank.probeAefDensmeterCoeffA < 0.1 && this.tank.probeAefDensmeterCoeffB > 0.1) {
        this.coefficientHeight = (this.densityFromDisplay(this.coefficientDensity) - this.tank.probeAefDensmeterCoeffB) / this.tank.probeAefDensmeterCoeffA
      }
    },
    onCoefficientChange () {
      if (this.coefficientHeight > 0.0 && this.coefficientDensity > 0.1 && this.coefficientDensityComp > 0.1) {
        var temp = this.tank.probeAefDensmeterCoeffA * this.coefficientHeight + this.tank.probeAefDensmeterCoeffB
        this.coefficientDensity = this.Maglink.RoundFormat(this.densityToDisplay(temp), 2)
        this.coefficientDensityComp = this.Maglink.RoundFormat(this.densityToDisplay(temp * this.coefficientBeta), 2)
      } else {
        this.calculateCoefficientHeight()
      }
    },
    onCoeffDensityChange () {
      if (this.coefficientHeight > 0.0 && this.coefficientDensity > 0.1) {
        var temp = this.densityFromDisplay(this.coefficientDensity)
        this.tank.probeAefDensmeterCoeffB = this.Maglink.RoundFormat(temp - this.tank.probeAefDensmeterCoeffA * this.coefficientHeight, 3)
        this.coefficientDensityComp = this.Maglink.RoundFormat(this.densityToDisplay(temp * this.coefficientBeta), 2)
      }
    },
    onCoeffDensityCompChange () {
      if (this.coefficientHeight > 0.0 && this.coefficientBeta > 0.0 && this.coefficientDensityComp > 0.1) {
        var temp = this.densityFromDisplay(this.coefficientDensityComp)
        this.coefficientDensity = this.Maglink.RoundFormat(this.densityToDisplay(temp / this.coefficientBeta), 2)
        this.tank.probeAefDensmeterCoeffB = this.Maglink.RoundFormat((temp / this.coefficientBeta) - this.tank.probeAefDensmeterCoeffA * this.coefficientHeight, 3)
      }
    },
    densityToDisplay (density) {
      if (this.isTankApiDegree) {
        return this.Maglink.toApiDegree(density)
      }
      return density
    },
    densityFromDisplay (density) {
      return this.Maglink.fromApiDegree(density)
    },
    applyT0 (e) {
      var level = this.Maglink.LevelFromDisplay(this.measurement.finePgAefLevel, this.systemSettings.levelUnit) * 1.0
      this.tank.aefT1outerLevel = this.Maglink.LevelToDisplay(level + 30.0, this.systemSettings.levelUnit)
      this.tank.aefT1innerLevel = this.Maglink.LevelToDisplay(level + 28.0, this.systemSettings.levelUnit)
      this.tank.aefT2innerLevel = this.Maglink.LevelToDisplay(level + 20.0, this.systemSettings.levelUnit)
      this.tank.aefT2outerLevel = this.Maglink.LevelToDisplay(level + 17.0, this.systemSettings.levelUnit)
      this.$forceUpdate()
      this.checkValues()
    },
    checkValues () {
      this.isFormAefValid = true
      if (this.isAefDensityType) {
        if (Math.abs(this.tank.probeAefDensmeterCoeffA) > 1.0 && Math.abs(this.tank.probeAefDensmeterCoeffB) < 1.0) {
          this.isFormAefValid = false
          return this.$t('Invalid coefficient values')
        }
        if (Math.abs(this.tank.probeAefDensmeterCoeffB) > 1.0 && Math.abs(this.tank.probeAefDensmeterCoeffA) < 1.0) {
          this.isFormAefValid = false
          return this.$t('Invalid coefficient values')
        }

        if (this.tank.densityCompManual > 315) {
          if (this.tank.densityCompManual > this.tank.aefSeparationThreshold + 0.01) {
            this.isFormAefValid = false
            return this.$t('Invalid threshold values')
          }
          if (this.tank.aefSeparationThreshold > this.tank.aefWaterThreshold + 0.01) {
            this.isFormAefValid = false
            return this.$t('Invalid threshold values')
          }
        } else {
          if (this.tank.densityCompManual + 0.1 < this.tank.aefSeparationThreshold) {
            this.isFormAefValid = false
            return this.$t('Invalid threshold values')
          }
          if (this.tank.aefSeparationThreshold + 0.1 < this.tank.aefWaterThreshold) {
            this.isFormAefValid = false
            return this.$t('Invalid threshold values')
          }
        }
      } else { // level thresholds
        if (this.tank.aefT2outerLevel > this.tank.aefT2innerLevel + 0.01) {
          this.isFormAefValid = false
          return this.$t('Invalid threshold values')
        }
        if (this.tank.aefT2innerLevel > this.tank.aefT1innerLevel + 0.01) {
          this.isFormAefValid = false
          return this.$t('Invalid threshold values')
        }
        if (this.tank.aefT1innerLevel > this.tank.aefT1outerLevel + 0.01) {
          this.isFormAefValid = false
          return this.$t('Invalid threshold values')
        }
      }

      return ''
    },
    saveTank (event) {
      if (this.$refs.formAef.validate()) {
        var msg = this.checkValues()
        if (!this.isFormAefValid) {
          this.snack('error', msg)
          return
        }
        this.$emit('tankSaved', this.tank.tankNumber)
      } else {
        this.isFormAefValid = false
      }
    },
    snack (color, message) {
      message = this.$t('Tank AEF') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
